import Vue from "vue";
import constants from '@/modules/common/utils/constants';

const URL_REGEX = /((https?:\/\/?[A-Za-z0-9._%+-])\S*[^\s.;,(){}<>])/gi

const LinkyTrust = Vue.filter('linkyTrust', function (input, target) {
  const targetHTML = target ? ` target="${target}"` : '';
  input = input.toString().replaceAll(URL_REGEX, `<a href="$1" ${targetHTML}>$1</a>`)

  if (constants.mobileApp()) {
    if (!window.openExternal) {
      window.openExternal = (url) => {
        Vue.prototype.$frontageApi.openExternal(url);
      }
    }
    const tempContainer = document.createElement('div')
    tempContainer.innerHTML = input
    let a = tempContainer.querySelectorAll('a')
    a.forEach(anchor => {
      let href = anchor.href;
      anchor.href = "#";
      anchor.setAttribute('onclick', `openExternal('${href}'); return false;`);
    })

    return tempContainer.innerHTML
  }

  return input
});

export default LinkyTrust
